/**
 * Checklist template — single source of truth for the tenant move-in task list.
 * Mirrors packages/shared/src/config/move-in-checklist-template.ts
 * Keep in sync when adding/removing/reordering tasks.
 */

export interface MoveInChecklistTemplateItem {
  type: 'APPOINTMENT' | 'INSURANCE_ALL' | 'UTILITIES' | 'RENT_SPLIT' | 'GENERAL';
  itemKey: string;
  label: string;
  category: string;
  sortOrder: number;
}

export const MOVE_IN_CHECKLIST_TEMPLATE: MoveInChecklistTemplateItem[] = [
  { type: 'APPOINTMENT', itemKey: 'appointment-booked', label: 'Book your move-in appointment', category: 'Appointment', sortOrder: 0 },
  { type: 'INSURANCE_ALL', itemKey: 'all-insurance-complete', label: 'All tenant insurance uploads are complete', category: 'Insurance', sortOrder: 1 },
  { type: 'GENERAL', itemKey: 'roommates-introduced', label: 'Introduce yourself to your roommates', category: 'Roommates', sortOrder: 2 },
  { type: 'UTILITIES', itemKey: 'utilities-enrollment-form-uploaded', label: 'Signed utility billing enrollment form uploaded', category: 'Utilities', sortOrder: 3 },
  { type: 'UTILITIES', itemKey: 'utilities-confirmed', label: 'Utilities account confirmed', category: 'Utilities', sortOrder: 4 },
  { type: 'RENT_SPLIT', itemKey: 'rent-split-confirmed', label: 'Confirm how rent will be split among tenants', category: 'Rent Split', sortOrder: 5 },
];
